// extracted by mini-css-extract-plugin
module.exports = {"ah084m5":"ah084m5"};